import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import styles from "./ReadinessGauge.module.css";

ChartJS.register(ArcElement, Tooltip, Legend);

const ReadinessGauge = ({ percentage, title = "Overall Readiness" }) => {
  // Safety check and parse percentage
  const safePercentage = parseFloat(percentage) || 0;

  const getColor = (pct) => {
    if (pct >= 80) return "#28a745";
    if (pct >= 60) return "#f57c00";
    return "#dc3545";
  };

  const data = {
    datasets: [
      {
        data: [safePercentage, 100 - safePercentage],
        backgroundColor: [getColor(safePercentage), "#e9ecef"],
        borderWidth: 0,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: true,
    cutout: "75%",
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true,
      },
      datalabels: {
        display: false,
      },
    },
  };

  const centerTextPlugin = {
    id: "centerText",
    beforeDraw: (chart) => {
      const { width, height, ctx } = chart;
      ctx.restore();
      const fontSize = (height / 114).toFixed(2);
      ctx.font = `bold ${fontSize}em Imprima, sans-serif`;
      ctx.textBaseline = "middle";

      const text = `${safePercentage.toFixed(2)}%`;
      const textX = Math.round((width - ctx.measureText(text).width) / 2);
      const textY = height / 2;

      ctx.fillStyle = getColor(safePercentage);
      ctx.fillText(text, textX, textY);
      ctx.save();
    },
  };

  return (
    <div className={styles.chartContainer}>
      <h3 className={styles.chartTitle}>{title}</h3>
      <div className={styles.gaugeWrapper}>
        <Doughnut data={data} options={options} plugins={[centerTextPlugin]} />
      </div>
    </div>
  );
};

export default ReadinessGauge;
